import React, { Component } from 'react'
import { connect } from 'react-redux'
import InvoiceLineItem from './InvoiceLineItem'

class InvoiceItems extends Component {
  render() {
    const { entrySummaryInvoices, expandAll, isDisabled , refreshESFrom,shipmentETA, currentJobData, isBrokerKnAdmin, countriesToCurrenciesConv, updateType, kxUserBasicInfo} = this.props

    return (
      <React.Fragment>
        {entrySummaryInvoices.map((item, index) => (
          <InvoiceLineItem
            invoice={item}
            isAggregateTab={this.props?.isAggregateTab}
            key={'invoiceLinItem' + item.invoiceId}
            modeOfTransport={this.props.modeOfTransport}
            invoiceItemIndex={index}
            validateFormzz={this.props.validateFormzz}
            totalInvoiceItems={entrySummaryInvoices.length}
            merchandiseItemCount={item.merchandiseLineItems.length}
            expandAll={expandAll}
            isDisabled={isDisabled}
            pscState={this.props.pscState}
            refreshESFrom={refreshESFrom}
            updateType={updateType}
            shipmentETA={shipmentETA}
            isBrokerKnAdmin={isBrokerKnAdmin}
            currentJobData={currentJobData}
            countriesToCurrenciesConv={countriesToCurrenciesConv}
            kxUserBasicInfo={kxUserBasicInfo}
          />
        ))}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({
  entrySummaryInvoices: state.DescriptionOfMerchandise.entrySummaryInvoices,
  fieldValidations: state.FieldValidation.fields || [],
  warnings: state.FieldValidation.warnings || []
})

const mapDispatchToProps = {}

export default React.memo(connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceItems))
